// extracted by mini-css-extract-plugin
module.exports = {"page":"Profile_page__3e3GW","main":"Profile_main__2Lbu8"};